import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { SurveyViewShared } from '../../components/PublicSurveys/SurveyViewShared';
import { CreateUpdateSurveyAnswerDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../translations';

export const PublicSurveyView: React.FC = () => {
  const [error, setError] = React.useState<string | null>(null);
  const { token } = useParams<{ token: string }>();
  const pok = usePokCore();
  const { t, tk } = useTranslation('administrationLng');

  const fetchSurvey = useCallback(
    (token: string) => pok.surveys.getByToken(token),
    [pok.surveys],
  );

  const handleComplete = async (
    answers: CreateUpdateSurveyAnswerDto[],
    surveyId: string,
  ) => {
    if (!token) {
      setError(t(tk.publicSurvey.submitError));
      return false;
    }
    try {
      await pok.surveys.submitAnswers(token, { surveyId, answers });
    } catch {
      setError(t(tk.publicSurvey.submitError));
      return false;
    }
    return true;
  };

  return (
    <SurveyViewShared
      identifier={token}
      submitError={error || undefined}
      fetchSurvey={fetchSurvey}
      onComplete={handleComplete}
    />
  );
};
